<template>
  <!--  <FormFieldNext
    v-if="isBinary"
    :disabled="resultTypeSettingsDisabledStates.switch"
    :label="$t('field.status.title')"
  >
    <AppRadioGroup
      :disabled="resultTypeSettingsDisabledStates.switch"
      :model-value="formModel.binaryValue"
      :name="`binary-type-${uniqueId}`"
      :options="getBinaryOptions"
      align-width
      class="ljiBinarySwitch"
      full-width
      :size="RADIO_GROUP_SIZES.LARGE"
      style="&#45;&#45;fill: #dfe1e6; &#45;&#45;option-padding: 4px 12px 4px 6px"
      @update:model-value="onBinaryValueUpdate"
    >
      <template #item-label="{ item }">
        <AppRadioGroupNextOptionWithIcon :option="item" centered gap="8px" />
      </template>
    </AppRadioGroup>
  </FormFieldNext>-->

  <ResultTypeSettingsPlug
    v-if="isBinary || isPlatformElementInAutoGrade"
    :is-binary="isBinary"
    :is-platform-element-in-auto-grade="isPlatformElementInAutoGrade"
  />

  <template v-else>
    <FormFieldNext v-if="isThreshold" :label="$t('common.condition')" class="rtsv-SelectField">
      <AppSelect
        v-model="conditionModel"
        :disabled="resultTypeSettingsDisabledStates.input"
        :offset="[0, 0]"
        :options="getConditionOptions"
        :type="SELECT_TYPES.MODERN"
      />
    </FormFieldNext>

    <AppInputNumberNext
      v-else
      :key="`original-value-field-${fieldTypeId}`"
      :digit-max-length="NUMBER_INPUT_DIGITS.ELEMENT_VALUES"
      :fraction="NUMBER_INPUT_FRACTIONS.ELEMENT_VALUES"
      :label="$t('create.keyResult.label.originalValue')"
      :model-value="getOriginalValue"
      :readonly="resultTypeSettingsDisabledStates.input"
      :suffix="getSuffix"
      allow-negative
      class="rtsv-Input"
      data-auto-testid="original-value-field"
      data-testid="original-value-field"
      return-value-as-string
      @blur="onOriginalValueBlur"
      @update:model-value="onOriginalValueUpdate"
    />

    <!--    <AppInputNumberNext
      v-if="isEdit"
      :key="`current-value-field-${fieldTypeId}`"
      ref="current"
      :digit-max-length="NUMBER_INPUT_DIGITS.ELEMENT_VALUES"
      :fraction="NUMBER_INPUT_FRACTIONS.ELEMENT_VALUES"
      :label="$t('create.keyResult.label.currentValue')"
      :model-value="getCurrentValue"
      :readonly="resultTypeSettingsDisabledStates.input"
      :suffix="getSuffix"
      allow-negative
      data-auto-testid="current-value-field"
      return-value-as-string
      @blur="onCurrentValueBlur"
      @update:model-value="onCurrentValueUpdate"
    />-->

    <AppInputNumberNext
      :key="`target-value-field-${fieldTypeId}`"
      :digit-max-length="NUMBER_INPUT_DIGITS.ELEMENT_VALUES"
      :fraction="NUMBER_INPUT_FRACTIONS.ELEMENT_VALUES"
      :label="targetValueLabel"
      :model-value="getTargetValue"
      :readonly="resultTypeSettingsDisabledStates.input"
      :suffix="getSuffix"
      allow-negative
      class="rtsv-Input"
      data-auto-testid="target-value-field"
      data-testid="target-value-field"
      return-value-as-string
      @blur="onTargetValueBlur"
      @update:model-value="onTargetValueUpdate"
    />
  </template>
</template>

<script setup>
import { isNull } from 'lodash'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { tracker } from '@/tracking/amplitude'
import {
  NUMBER_INPUT_DIGITS,
  NUMBER_INPUT_FRACTIONS
} from '@/utils/components-configurations/app-input-number'
import { SELECT_TYPES } from '@/utils/components-configurations/app-select'
import { KR_VALUE_TYPES } from '@/utils/metrics-helpers'
import {
  DEFAULT_ORIGINAL_VALUE,
  DEFAULT_TARGET_VALUE,
  getConditionParameterById,
  getResultTypeSettingsDisabledStates,
  THRESHOLD_CONDITIONS
} from '@/utils/okr-element-values'
import { MATH_SYMBOLS } from '@/utils/okr-elements/math'

import FormFieldNext from '@/components/form/FormFieldNext'
import ResultTypeSettingsPlug from '@/components/form/ResultTypeSettingsPlug'
import AppInputNumberNext from '@/components/ui/AppInputNumberNext/AppInputNumberNext'
import AppSelect from '@/components/ui/AppSelect/AppSelect'

defineOptions({
  name: 'ResultTypeSettingsDefaultRightSide',
  inheritAttrs: false
})
const props = defineProps({
  isBinary: {
    type: Boolean
  },

  isPlatformElementInAutoGrade: {
    type: Boolean
  },

  isThreshold: {
    type: Boolean
  },

  isEdit: {
    type: Boolean
  },

  editable: {
    type: Boolean
  },

  valuesAreReadonly: {
    type: Boolean
  },

  isLockedOnPercent: {
    type: Boolean
  },

  isBinarySelectDisabled: {
    type: Boolean
  },

  // formModel: {
  //   type: Object,
  //   default: () => ({})
  // },

  originalValue: {
    type: [Number, String],
    default: 0
  },

  // currentValue: {
  //   type: [Number, String],
  //   default: 0
  // },

  targetValue: {
    type: [Number, String],
    default: 0
  },

  // isAutoMode: {
  //   type: Boolean,
  //   default: false
  // },

  fieldTypeId: {
    type: [String, Number],
    default: KR_VALUE_TYPES.START_TARGET
  },

  unit: {
    type: String,
    default: ''
  }
})

const conditionModel = defineModel('thresholdCondition', {
  type: Number,
  default: THRESHOLD_CONDITIONS.BELOW_OR_EQUAL.value,
  validator: v =>
    Object.values(THRESHOLD_CONDITIONS)
      .map(({ value }) => value)
      .includes(v),
  set: value => {
    if (props.isEdit) {
      const label = getConditionParameterById({
        conditionId: value
      })

      tracker.logEvent('changed threshold condition', {
        threshold_condition: t(label, 1, {
          locale: 'en'
        }).toLowerCase()
      })
    }

    return value
  }
})

// const uniqueId = useId()

const emit = defineEmits({
  'update:binary-value': null,
  'update:original-value': null,
  'blur-original-value': null,
  'update:current-value': null,
  'blur-current-value': null,
  'update:target-value': null,
  'blur-target-value': null
})

// onMounted(() => {
//   if (props.isEdit && !props.valuesAreReadonly && !props.isBinary && !props.isAutoMode) {
//     setFocusOnCurrent()
//   }
// })
// const current = ref(null)
// const setFocusOnCurrent = () => {
//   // nextTick and setTimeout(both!) are needed to make input always focused on modal window
//   // opening because modal window(o-modal) has transition of opacity with 0.2s
//   nextTick(() => {
//     setTimeout(() => {
//       if (current.value) {
//         current.value.selectAll()
//       }
//     }, 100)
//   })
// }

const getOriginalValue = computed(() => {
  return isNull(props.originalValue) ? DEFAULT_ORIGINAL_VALUE : props.originalValue // after link jira-issue in autoMode we get null from backend
})

// const getCurrentValue = computed(() => {
//   return isNull(props.currentValue) ? DEFAULT_CURRENT_VALUE : props.currentValue // after link jira-issue in autoMode we get null from backend
// })

const getTargetValue = computed(() => {
  return isNull(props.targetValue) ? DEFAULT_TARGET_VALUE : props.targetValue // after link jira-issue in autoMode we get null from backend
})

// const onBinaryValueUpdate = value => {
//   emit('update:binary-value', value)
// }

const onOriginalValueUpdate = value => {
  emit('update:original-value', value)
}

const onOriginalValueBlur = () => {
  emit('blur-original-value')
}

//const onCurrentValueUpdate = value => {
//  emit('update:current-value', value)
//}

// const onCurrentValueBlur = () => {
//   emit('blur-current-value')
// }

const onTargetValueUpdate = value => {
  emit('update:target-value', value)
}

const onTargetValueBlur = value => {
  emit('blur-target-value', value)
}

const resultTypeSettingsDisabledStates = computed(() => {
  const { select, isSwitch, input } = getResultTypeSettingsDisabledStates({
    isEdit: props.isEdit,
    editable: props.editable,
    isLockedOnPercent: props.isLockedOnPercent,
    isBinarySelectDisabled: props.isBinarySelectDisabled,
    valuesAreReadonly: props.valuesAreReadonly
  })
  return {
    select,
    switch: isSwitch,
    input
  }
})

// const getBinaryOptions = computed(() => {
//   return BINARY_OPTIONS
// })

const getSuffix = computed(() => {
  if (props.isLockedOnPercent) {
    return MATH_SYMBOLS.PERCENT
  }

  return props.unit || ''
})

const { t } = useI18n()

const getConditionOptions = computed(() => {
  return Object.values(THRESHOLD_CONDITIONS).map(option => {
    return {
      ...option,
      label: `${t(option.label)} (${option.symbol})`.trim()
    }
  })
})

const targetValueLabel = computed(() => {
  return props.isThreshold ? t('objectives.threshold') : t('create.keyResult.label.targetValue')
})
</script>

<style lang="scss" scoped>
.rtsv-Input {
  --font-size: #{$fs-14};

  &:deep(.ain-InputWrapper) {
    width: 100%;
  }
}

.rtsv-SelectField {
  overflow: hidden;
  --button-text-font-weight: #{fw('semi-bold')};
  --disabled-opacity: 1;
  --button-disabled-color: #{$dark-3};
  --button-disabled-border-color: #{$grey-2-next};
  --button-disabled-background-color: #{$grey-2-next};
}
</style>
